export const OSLO_TIME_ZONE = 'Europe/Oslo';
export const MEETING_HOUR_OSLO = 11;

const weekdayIndex = {
  Sun: 0,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6
};

const partsForOslo = (date) => Object.fromEntries(
  new Intl.DateTimeFormat('en-CA', {
    timeZone: OSLO_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    weekday: 'short',
    hour: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(date).filter((part) => part.type !== 'literal').map((part) => [part.type, part.value])
);

const addDays = (dateValue, days) => {
  const date = new Date(`${dateValue}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};

export const osloToday = (now = new Date()) => {
  const parts = partsForOslo(now);
  return `${parts.year}-${parts.month}-${parts.day}`;
};

export const scheduledSundayForNow = (now = new Date()) => {
  const parts = partsForOslo(now);
  const today = `${parts.year}-${parts.month}-${parts.day}`;
  const day = weekdayIndex[parts.weekday];
  const daysUntilSunday = (7 - day) % 7;
  return addDays(today, daysUntilSunday);
};

export const nextSundayAfter = (dateValue) => {
  const date = new Date(`${dateValue}T12:00:00Z`);
  const day = date.getUTCDay();
  return addDays(dateValue, day === 0 ? 7 : 7 - day);
};

export const isFirstSundayOfMonth = (dateValue) => Number(dateValue.slice(8, 10)) <= 7;

export const formatSundaySchedule = (dateValue) => {
  const date = new Date(`${dateValue}T12:00:00Z`);
  const day = new Intl.DateTimeFormat('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(date);
  return `${day} · 11:00 Norway time`;
};

export const scheduleStatus = (dateValue, now = new Date()) => {
  const today = osloToday(now);
  if (dateValue < today) return 'Overdue';
  if (dateValue === today) return 'Today';
  return 'Scheduled';
};
